/**
 * Created by ziv on 7/12/16.
 */
 import React from 'react';
 import ReactDOM from 'react-dom';
 import {Chart} from 'react-google-charts';
 import Paper from 'material-ui/Paper';
 var numeral = require('numeral');
 const paperStyle = {
 	boxShadow: 'rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px',
 	height:'100%',

	// width: '30%',

};
// var total = 0;

export default class SectorsPie extends React.Component {
	componentDidMount(){

		// console.log("pie componentDidMount");
		var total = this.props.total;
		
		var formatted = this.formatDataForPie(this.props.data, total);

		this.setState({data:formatted})
		// window.analytics.page('Build');
	}
	formatDataForPie(sectors, total){
		if(!sectors){
			return [];
		}
		var formatted = [['sectors','size']];
		// console.log("===== sectors", sectors)
		// console.log("formatDataForPie", total)
		var cash = total;

		for (var i = sectors.length - 1; i >= 0; i--) {
			var sector = sectors[i]
			// console.log(sector, cash, total)

			if(sector.selected){
				cash = cash - sector.size;
				formatted.push([
					sector.name,
					Number(numeral((sector.size / total) * 100).format('0,0.[0]')),
					])

				// formatted.push({
				// 	label:sector.name,
				// 	value:numeral((sector.size / total) * 100).format('0,0.[0]'),
				// 	name: sector.name,
				// 	field: sector.name,
				// });  
			}	

		} 	
		if(cash > 0){
			formatted.push([
				"Cash",
				Number(numeral((cash / total) * 100).format('0,0.[0]')),
			])
		}
		// console.log(formatted)		
			// console.log("after loop", cash, total)

		// if(cash > 0){
		// 	formatted.push({label:"Cash", value:(cash /total) * 100 });
		// }
		// console.log(formatted);
		return formatted;
	}
	// get
	constructor(props, context) {
		super(props, context);
		this.state = {data:[]};
	}
	componentWillUpdate(nextProps, nextState){

		// console.log("pie componentWillUpdate");
		// console.log(nextProps, nextState);
		// console.log(nextProps !== this.props);
		var total = nextProps.total;
		if(nextProps !== this.props){
			// console.log("should update pie");
			// console.log(nextProps.total);

			var formatted = this.formatDataForPie(nextProps.data, total);
			this.setState({data:formatted});
		}

	}
	// componentDidUpdate(prevProps, prevState){
	// 	console.log("pie componentDidUpdate");
	// 	console.log(prevProps, prevState);

	// }

	render(){
		
		return(
			<div style={this.props.style}>
			<Paper zDepth={2} style={paperStyle} >
			{
						//[["Task","Hours per Day"],["Work",11],["Eat",2],["Commute",2],["Watch TV",2],["Sleep",7]]
					}
					<Chart
					chartType="PieChart" 
					data={this.state.data}
					options={
						{
							legend:{ 
								position: 'labeled' 
							},
							chartArea:
							{ 
								left:'25',
								top:'10',
								width:"90%",
								height:"90%"
							}
						}
					}
					width="100%"
					height="100%"
					legend_toggle
					/>
					{
					      	// <PieChart data={data} width={455}
					      	// 			  height={440}
					      	// 			  radius={30}
					      	// 			  innerRadius={0}
					      	// 			  sectorBorderColor="white"
					      	// 			  name={this.getName} 
					      	// 			  value={this.getValue}
					      	// 			  chartSeries= {chartSeries}



					      	// 			  title=""/>
					      }

					      </Paper>
					      </div>			
					      );		

	}
}


// WEBPACK FOOTER //
// ./src/js/components/SectorsPie.js